import { makeStyles } from '@material-ui/core/styles';
import { createRoot, createFormLayout } from '../common';

const useStyles = makeStyles((theme) => ({
  root: {
    ...createRoot(theme),
    [theme.breakpoints.down('sm')]: {
      '& .MuiGrid-root.MuiGrid-item:nth-child(odd)': {
        paddingRight: 0,
      },
      '& .MuiGrid-root.MuiGrid-item:nth-child(even)': {
        paddingLeft: 0,
      },
      '& .MuiButtonBase-root.MuiButton-containedPrimary': {
        margin: '16px 0 0',
        maxWidth: '100%',
      },
    },

    '& .actions': {
      padding: '0 !important',
    },
  },
  layout: {
    ...createFormLayout(theme),
  },

  modalContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 24,
    paddingRight: 40,
    width: '100%',

    '& button': {
      minWidth: 40,
      zIndex: 1,

      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },

    '& svg': {
      transform: 'scale(1.5)',
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: 508,
      marginBottom: '-20px',
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: 'auto',
      marginBottom: '-50px',
    },
  },

  siginCard: {
    marginBottom: 30,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey1,

    '& .card-content': {
      display: 'flex',
      gap: 20,
      flexDirection: 'column',
      padding: '30px 20px',

      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        alignItems: 'center',
      },
    },

    '& .description': {
      [theme.breakpoints.up('sm')]: {
        maxWidth: '65%',
      },
    },
    '& button': {
      marginLeft: 20,
    },
    '& + .form__subTitle': {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  textFields: {
    '& .MuiInputLabel-shrink': {
      fontSize: 18,
      [theme.breakpoints.down('sm')]: {
        fontSize: 19,
      },
    },
  },
  dateInputs: {
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    '& .MuiSelect-root': {
      fontFamily: theme.typography.proxima.regular,
    },
    '& .MuiGrid-root.MuiGrid-item': {
      maxWidth: '32%',
      padding: '0 !important',
      margin: '0 !important',
      '& .MuiFormControl-root': {
        width: '100%',
      },
    },
    '& .MuiGrid-root.MuiGrid-item:first-child': {
      '& legend': {
        width: 300,
      },
    },
    '& legend': {
      paddingBottom: 6,
    },
    [theme.breakpoints.down('sm')]: {
      '&.MuiGrid-root.MuiGrid-item': {
        padding: '0 !important',
      },
    },
  },
  selectShip: {
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiSelect-select': {
      paddingLeft: '20px',
    },
    '& legend': {
      paddingBottom: 6,
    },
    '& svg': {
      zIndex: 1,
      [theme.breakpoints.only('xl')]: {
        marginLeft: 12,
      },
    },
    [theme.breakpoints.down('sm')]: {
      '&.MuiGrid-root.MuiGrid-item': {
        paddingTop: 10,
      },
    },
  },
  optionsHeight: {
    maxHeight: '200px',
  },
}));

export default useStyles;
